import { Component } from '@angular/core';

@Component({
  selector: 'app-pushpak-engineering-india-pvt-ltd',
  templateUrl: './pushpak-engineering-india-pvt-ltd.component.html',
  styleUrls: ['./pushpak-engineering-india-pvt-ltd.component.scss']
})
export class PushpakEngineeringIndiaPvtLtdComponent {

}
